import { useQuery } from '@tanstack/react-query';

import { fetchUrlMetadata } from '../../services/urlMetadata.service';

/**
 * A page's title and favicon from the chat-sources resolver
 * (`GET /api/utils/url-metadata`), for the link form's prefill. Pass null to
 * fetch nothing (no valid URL yet). The service keeps its own one-hour cache
 * and never rejects: a failed lookup resolves to empty metadata.
 */
export function useUrlMetadata(url: string | null) {
  return useQuery({
    queryKey: ['url-metadata', url],
    queryFn: () => fetchUrlMetadata(url as string),
    enabled: url !== null,
    staleTime: 60 * 60 * 1000,
    retry: false,
  });
}
